module.exports = __webpack_public_path__ + "static/media/moon_red-min.48f4f852.png";